module.exports = __webpack_public_path__ + "static/media/H.cf67ba42.jpg";